<template>
  <page-listado :fluid="true">
    <page-header title="Módulos">
      <b-button variant="primary" size="sm" to="/modulos/crear">
        <v-icon name="plus" width="16" />
        Crear modulo
      </b-button>
      <busqueda-rapida />
    </page-header>

    <tabla :modulos="resultado.modulos" />
    <paginacion :page-count="resultado.numeroPaginas" :page="resultado.pagina" />
  </page-listado>
</template>

<script>
import * as modulosApi from "@/services/modulos.js";
import Tabla from "./TablaModulos.vue";
export default {
  components: { Tabla },
  data() {
    return {
      resultado: {
        modulos: [],
        numeroPaginas: 0,
        pagina: 1,
      },
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    listar() {
      return modulosApi.listar(this.$route.query).then((resultado) => {
        this.resultado = resultado;
      });
    },
  },
};
</script>
